import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { ProductSearchComponent } from '../../pdv/product-search/product-search.component';
import { ProductListComponent } from '../../pdv/product-list/product-list.component';
import { CustomerSearchComponent } from '../../pdv/customer-search/customer-search.component';
import { CustomerInputComponent } from '../../pdv/customer-input/customer-input.component';
import { DiscountInputComponent } from '../../pdv/discount-input/discount-input.component';
import { HelpComponent } from '../../pdv/help/help.component';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { CreateSaleFromPdvDto } from '../../pdv/create-sale-from-pdv-dto';
import { Product } from '../../../models/product.model';
import { Customer } from '../../../models/customer.model';
import { FormsModule } from "@angular/forms";
import { ProductService } from '../../../services/product.service';
import { ActionCommandService, ActionCommand } from '../../../services/action-command.service';
import { CustomerService } from '../../../services/customer.service';
import { PreVendaService } from '../../../services/pre-venda.service';

@Component({
  selector: 'app-pre-vendas-pdv',
  imports: [
    CommonModule,
    ProductSearchComponent,
    ProductListComponent,
    CustomerSearchComponent,
    CustomerInputComponent,
    DiscountInputComponent,
    HelpComponent,
    InputTextModule,
    TableModule,
    ButtonModule,
    InputNumberModule,
    FormsModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './pre-vendas-pdv.component.html'
})
export class PreVendasPdvComponent implements OnInit, OnDestroy {
  
  @ViewChild(ProductSearchComponent) productSearchComponent!: ProductSearchComponent;
  @ViewChild(CustomerSearchComponent) customerSearchComponent!: CustomerSearchComponent;
  
  menuOpened = '';
  customerSearch: string = '';
  status = 'PRÉ-VENDA';
  customerDocument: string = '';

  preVenda: CreateSaleFromPdvDto = {
    discountTotal: 0,
    exchange: 0,
    grossTotal: 0,
    netTotal: 0,
    items: [],
    customerName: '',
    customerId: null,
    paymentMethod: '',
    employeeId: null,
    shiftId: null
  } as CreateSaleFromPdvDto;

  amount: number = 0;
  search: string = '';

  totalItens = 0;
  valorTotal = 0;

  // Navegação entre itens da pré-venda
  selectedItemIndex: number = -1;

  constructor(
    private productService: ProductService,
    private actionCommandService: ActionCommandService,
    private customerService: CustomerService,
    private preVendaService: PreVendaService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F5 para salvar pré-venda
    this.actionCommandService.registerCommand({
      getKey: () => 'F5',
      execute: () => this.salvarPreVenda(),
      getDescription: () => 'Salvar Pré-Venda'
    });

    // Registrar comando F6 para cancelar
    this.actionCommandService.registerCommand({
      getKey: () => 'F6',
      execute: () => this.cancelarPreVenda(),
      getDescription: () => 'Cancelar Pré-Venda'
    });

    // Registrar comando F2 para buscar cliente
    this.actionCommandService.registerCommand({
      getKey: () => 'F2',
      execute: () => this.openCustomerSearch(),
      getDescription: () => 'Buscar Cliente'
    });

    // Registrar comando F3 para desconto
    this.actionCommandService.registerCommand({
      getKey: () => 'F3',
      execute: () => this.openDiscountInput(),
      getDescription: () => 'Desconto'
    });

    // Registrar comando F7 para CPF/CNPJ
    this.actionCommandService.registerCommand({
      getKey: () => 'F7',
      execute: () => this.openCustomerInput(),
      getDescription: () => 'CPF/CNPJ'
    });

    // Registrar comando F11 para lista de produtos
    this.actionCommandService.registerCommand({
      getKey: () => 'F11',
      execute: () => this.openProductList(),
      getDescription: () => 'Lista de Produtos'
    });

    // Registrar comando F1 para ajuda
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.openHelp(),
      getDescription: () => 'Ajuda'
    });

    // Registrar setas para navegação
    this.actionCommandService.registerCommand({
      getKey: () => 'ArrowDown',
      execute: () => this.navigateDown(),
      getDescription: () => 'Navegar para baixo'
    });

    this.actionCommandService.registerCommand({
      getKey: () => 'ArrowUp',
      execute: () => this.navigateUp(),
      getDescription: () => 'Navegar para cima'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F5');
    this.actionCommandService.unregisterCommand('F6');
    this.actionCommandService.unregisterCommand('F2');
    this.actionCommandService.unregisterCommand('F3');
    this.actionCommandService.unregisterCommand('F7');
    this.actionCommandService.unregisterCommand('F11');
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ArrowDown');
    this.actionCommandService.unregisterCommand('ArrowUp');
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    // Permitir ESC para fechar qualquer menu
    if(event.key === 'Escape') {
      this.closeMenu();
    }
  }

  private navigateDown(): void {
    if(this.preVenda.items.length > 0){
      this.selectedItemIndex = Math.min(this.selectedItemIndex + 1, this.preVenda.items.length - 1);
      this.scrollToSelectedItem();
    }
  }

  private navigateUp(): void {
    if(this.preVenda.items.length > 0){
      this.selectedItemIndex = Math.max(this.selectedItemIndex - 1, -1);
      this.scrollToSelectedItem();
    }
  }

  private scrollToSelectedItem(): void {
    if (this.selectedItemIndex >= 0 && this.selectedItemIndex < this.preVenda.items.length) {
      setTimeout(() => {
        const element = document.getElementById(`pre-venda-item-${this.selectedItemIndex}`);
        const container = document.getElementById('itensTable');
        
        if(element && container) {
          const elementRect = element.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          
          const isVisible = (
            elementRect.top >= containerRect.top &&
            elementRect.bottom <= containerRect.bottom
          );
          
          if(!isVisible) {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 0);
    }
  }

  addItem(product: Product){
    this.preVenda.grossTotal += this.amount * product.priceSelling;
    this.preVenda.netTotal = this.preVenda.grossTotal - this.preVenda.discountTotal;

    this.preVenda.items.unshift({
      productId: product.id,
      productName: product.description,
      amount: this.amount,
      productPrice: product.priceSelling,
      total: this.amount * product.priceSelling,
      productBarCode: product.barCode,
      productCode: product.code,
      costPrice: product.priceCost,
      listPriceSelling: product.listPriceSelling ?? null,
      promotionId: product.promotionId ?? null,
      promotionDescription: product.promotionDescription ?? null
    });

    this.search = '';
    this.amount = 1;
    this.selectedItemIndex = -1;
  }

  addQuantity(item: any): void {
    item.amount += 1;
    item.total = item.amount * item.productPrice;
    this.recalculateTotals();
  }

  subtractQuantity(item: any): void {
    if (item.amount > 1) {
      item.amount -= 1;
      item.total = item.amount * item.productPrice;
      this.recalculateTotals();
    }
  }

  deleteItem(item: any): void {
    const index = this.preVenda.items.indexOf(item);
    if (index > -1) {
      this.preVenda.items.splice(index, 1);
      this.recalculateTotals();
      this.selectedItemIndex = -1;
    }
  }

  private recalculateTotals(): void {
    this.preVenda.grossTotal = this.preVenda.items.reduce((sum, item) => sum + item.total, 0);
    this.preVenda.netTotal = this.preVenda.grossTotal - this.preVenda.discountTotal;
  }

  openHelp(): void {
    if(this.menuOpened === 'HELP') {
      this.closeMenu();
    } else {
      this.menuOpened = 'HELP';
    }
  }

  openCustomerSearch(): void {
    if(this.menuOpened === 'CUSTOMER_SEARCH') {
      this.closeMenu();
    } else {
      this.menuOpened = 'CUSTOMER_SEARCH';
    }
  }

  openDiscountInput(): void {
    if(this.menuOpened === 'DISCOUNT_INPUT') {
      this.closeMenu();
    } else {
      this.menuOpened = 'DISCOUNT_INPUT';
    }
  }

  openCustomerInput(): void {
    if(this.menuOpened === 'CUSTOMER_INPUT') {
      this.closeMenu();
    } else {
      this.menuOpened = 'CUSTOMER_INPUT';
    }
  }

  openProductList(): void {
    if(this.menuOpened === 'PRODUCT_LIST') {
      this.closeMenu();
    } else {
      this.menuOpened = 'PRODUCT_LIST';
    }
  }

  closeMenu(): void {
    this.menuOpened = '';
    this.registerCommands();
    this.focusProductSearchInput();
  }

  private focusProductSearchInput(): void {
    setTimeout(() => {
      const searchInput = document.getElementById('search');
      if (searchInput) {
        const isVisible = searchInput.offsetParent !== null;
        if (isVisible) {
          searchInput.focus();
        } else {
          setTimeout(() => {
            const retryInput = document.getElementById('search');
            if (retryInput && retryInput.offsetParent !== null) {
              retryInput.focus();
            }
          }, 50);
        }
      }
    }, 0);
  }

  onDiscountConfirmed(discountAmount: number): void {
    this.preVenda.discountTotal = discountAmount;
    this.preVenda.netTotal = this.preVenda.grossTotal - this.preVenda.discountTotal;
    this.closeMenu();
  }

  onCustomerSearchKeyup(event: any): void {
    if(this.customerSearchComponent) {
      this.customerSearchComponent.onSearchKeyup(event);
    }
  }

  onCustomerSearchInput(): void {
    if(this.customerSearchComponent) {
      this.customerSearchComponent.onSearchInputChange(this.customerSearch);
    }
  }

  onCustomerSelected(customer: Customer): void {
    this.preVenda.customerId = customer.id;
    this.preVenda.customerName = customer.fullName;
    this.customerDocument = customer.cpf || '';
    this.closeMenu();
  }

  onCustomerDataChange(data: {name: string, document: string}): void {
    this.preVenda.customerName = data.name;
    this.customerDocument = data.document || '';
    this.preVenda.customerId = null;
  }

  onCustomerConfirmed(data: {name: string, document: string}): void {
    this.preVenda.customerName = data.name;
    this.customerDocument = data.document || '';
    this.preVenda.customerId = null;
    this.closeMenu();
  }

  clearPreVenda(): void {
    this.preVenda = {
      customerName: '',
      customerId: null,
      items: [],
      discountTotal: 0,
      exchange: 0,
      grossTotal: 0,
      netTotal: 0,
      paymentMethod: '',
      employeeId: null,
      shiftId: null
    } as CreateSaleFromPdvDto;
    
    this.customerDocument = '';
    this.search = '';
    this.amount = 1;
    this.selectedItemIndex = -1;
    this.menuOpened = '';
    
    setTimeout(() => {
      this.focusProductSearchInput();
    }, 300);
  }

  cancelarPreVenda(): void {
    if (confirm('Tem certeza que deseja cancelar a pré-venda em andamento? Todos os itens serão removidos.')) {
      this.clearPreVenda();
      this.closeMenu();
    }
  }

  onProductSelected(event: {product: Product, amount: number}): void {
    this.amount = event.amount;
    this.addItem(event.product);
    this.selectedItemIndex = -1;
    this.search = '';
    if(this.menuOpened === 'PRODUCT_LIST') {
      this.closeMenu();
    }
  }

  onCodeSearchRequested(event: {searchTerm: string, amount: number}): void {
    this.amount = event.amount;
    this.productService.getByCodeOrBarCode(event.searchTerm, true).subscribe({
      next: (response) => {
        if(response.data != null){
          this.addItem(response.data);
        }
      },
      error: (err) => {
      }
    });
    this.search = '';
  }

  onSearchKeyup(event: any): void {
    if(this.productSearchComponent) {
      this.productSearchComponent.onSearchKeyup(event);
    }
  }

  onSearchInput(): void {
    if(this.productSearchComponent) {
      this.productSearchComponent.onSearchInputChange(this.search);
    }
  }

  salvarPreVenda(): void {
    if (this.preVenda.items.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Adicione pelo menos um produto à pré-venda.',
        life: 4000
      });
      return;
    }

    if (!confirm('Deseja realmente finalizar e salvar esta pré-venda?')) {
      return;
    }

    this.preVendaService.create(this.preVenda, {
      cpfCnpj: this.customerDocument || undefined,
      employeeId: this.preVenda.employeeId ?? undefined
    }).subscribe({
      next: (response) => {
        if (response.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso!',
            detail: response.message || 'Pré-venda salva com sucesso!',
            life: 3000
          });
          this.clearPreVenda();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro!',
            detail: response.message || 'Erro ao salvar pré-venda.',
            life: 5000
          });
        }
      },
      error: (err) => {
        const detail = err?.error?.message ?? err?.message ?? 'Erro ao salvar pré-venda. Tente novamente.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail,
          life: 5000
        });
      }
    });
  }
}
